<template>
    <upload-image
        v-model="logo"
        class="upload-image"
        :max-size="500 * 1024"
        cover
        desc="图片尺寸不小于 24x24 像素，不超过 500K，支持 SVG/PNG/JPG 格式"
        :upload-method="uploadMethod"
    >
        <template #cover>
            <img class="upload-image__cover" src="../../../../../assets/app-brand.svg" />
        </template>
    </upload-image>
</template>

<script>
import axios from '@/utils/axios';

export default {
    name: 'TheUploadLogo',

    model: {
        prop: 'value',
        event: 'update:value'
    },

    props: {
        configType: {
            type: String,
            default: ''
        },

        value: {
            type: String,
            default: ''
        }
    },

    computed: {
        logo: {
            get() {
                return this.value ? [this.value] : [];
            },
            set(value) {
                this.$emit('update:value', value[0] || '');
            }
        }
    },

    methods: {
        async uploadMethod(upload, progress) {
            upload.fd.append('configType', this.configType);
            upload.fd.append('pictureType', 'logo');
            upload.fd.append('used', 1);
            const data = await axios.post('/api/ops/config/picture/upload', upload.fd, {
                onUploadProgress: progress
            });
            const url = data.pictureUrl;
            this.$emit('success', url);
            return url;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/var';

.upload-image {
    ::v-deep {
        .image,
        .image__img {
            background-color: $desk-background-color;
        }
    }

    &__cover {
        width: 100%;
        height: 100%;
        padding: 8px;
    }
}
</style>
